const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID ||
  (typeof window !== "undefined" ? window.__DALMO_GA_MEASUREMENT_ID__ : "");

const TRACKED_DOMAINS = [
  "hiredalmo.com",
  "dalmo.ai",
  "future.hiredalmo.com",
  "morechart.hiredalmo.com",
  "integral.hiredalmo.com",
  "places.hiredalmo.com",
  "bots.hiredalmo.com",
  "digest.hiredalmo.com",
  "oneprompt.hiredalmo.com",
  "nvc.hiredalmo.com",
  "cappuccino.hiredalmo.com",
  "facts.hiredalmo.com",
  "false.hiredalmo.com",
  "lockin.hiredalmo.com",
  "landmarkle.hiredalmo.com",
  "lime.hiredalmo.com",
  "future.dalmo.ai",
  "integral.dalmo.ai"
];

let initialized = false;
let outboundListenerAttached = false;

function isLocalHost() {
  if (typeof window === "undefined") return true;
  return ["localhost", "127.0.0.1", ""].includes(window.location.hostname);
}

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

function attachOutboundTracking(siteName) {
  if (outboundListenerAttached || typeof document === "undefined") return;
  outboundListenerAttached = true;

  document.addEventListener("click", event => {
    const anchor = event.target.closest?.("a[href]");
    if (!anchor || !anchor.href) return;

    const url = new URL(anchor.href, window.location.href);
    if (url.hostname === window.location.hostname) return;

    const isContactLink = /linkedin\.com|mailto:|calendly\.com|github\.com/.test(url.href);
    const isProjectLink = anchor.closest?.("[data-project-card], [data-project-link]");

    trackEvent("outbound_click", {
      event_category: "outbound",
      event_label: url.href,
      link_domain: url.hostname,
      link_url: url.href,
      site_name: siteName
    });

    if (isProjectLink) {
      trackEvent("project_click", {
        event_category: "project",
        event_label: anchor.getAttribute("data-project-title") || anchor.textContent?.trim() || url.href,
        link_domain: url.hostname,
        link_url: url.href,
        site_name: siteName
      });
    }

    if (isContactLink) {
      trackEvent("contact_click", {
        event_category: "contact",
        event_label: anchor.getAttribute("aria-label") || anchor.textContent?.trim() || url.href,
        link_domain: url.hostname,
        link_url: url.href,
        site_name: siteName
      });
    }
  });
}

export function initAnalytics(siteName = "hiredalmo") {
  if (initialized || !GA_MEASUREMENT_ID || isLocalHost()) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || gtag;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
  document.head.appendChild(script);

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
    linker: { domains: TRACKED_DOMAINS },
    site_name: siteName
  });

  attachOutboundTracking(siteName);
  initialized = true;
}

export function trackPageView({ path, title, location, siteName = "hiredalmo" }) {
  if (!GA_MEASUREMENT_ID || isLocalHost()) return;
  initAnalytics(siteName);

  window.gtag?.("event", "page_view", {
    page_path: path || window.location.pathname,
    page_title: title || document.title,
    page_location: location || window.location.href,
    site_name: siteName
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_MEASUREMENT_ID || isLocalHost()) return;
  window.gtag?.("event", name, params);
}

export function trackWebVital(metric) {
  trackEvent(metric.name, {
    event_category: "Web Vitals",
    event_label: metric.id,
    non_interaction: true,
    value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value)
  });
}
